import { render, staticRenderFns } from "./DashboardPlacementCompletionItem.vue?vue&type=template&id=2a2027ec&"
import script from "./DashboardPlacementCompletionItem.vue?vue&type=script&lang=js&"
export * from "./DashboardPlacementCompletionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports